import { render, staticRenderFns } from "./step-list.vue?vue&type=template&id=3b6def20&scoped=true&"
import script from "./step-list.vue?vue&type=script&lang=js&"
export * from "./step-list.vue?vue&type=script&lang=js&"
import style0 from "./step-list.vue?vue&type=style&index=0&id=3b6def20&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6def20",
  null
  
)

export default component.exports